export const HOME = { emergentLink: "home-emergent-link" };

export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitButton: "login-submit-button",
};

export const NAV = {
  logoutButton: "logout-button",
  sidebarToggle: "sidebar-toggle",
};

export const DASHBOARD = {
  kpiCari: "kpi-cari",
  kpiStok: "kpi-stok",
  kpiSiparis: "kpi-siparis",
  kpiCiro: "kpi-ciro",
  recentOrdersTable: "recent-orders-table",
  eurKuruDisplay: "eur-kuru-display",
};

export const CARI = {
  listTable: "cari-list-table",
  searchInput: "cari-search-input",
  createButton: "cari-create-button",
  saveButton: "cari-save-button",
};

export const STOK = {
  listTable: "stok-list-table",
  searchInput: "stok-search-input",
  createButton: "stok-create-button",
  brandFilter: "stok-brand-filter",
};

export const SIPARIS = {
  listTable: "siparis-list-table",
  statusFilter: "siparis-status-filter",
  durumUpdate: "siparis-durum-update",
};

export const EXCEL = {
  moduleSelect: "excel-module-select",
  fileUpload: "excel-file-upload",
  previewTable: "excel-preview-table",
  importButton: "excel-import-button",
  fieldMappingRow: "excel-field-mapping-row",
};

export const USER = {
  listTable: "user-list-table",
  createButton: "user-create-button",
};

export const AYARLAR = {
  eurInput: "eur-kuru-input",
  eurSave: "eur-kuru-save",
  tcmbFetch: "tcmb-fetch-button",
};

export const B2B = {
  stokTable: "b2b-stok-table",
  addToCart: "b2b-add-to-cart",
  cartTable: "b2b-cart-table",
  orderSubmit: "b2b-order-submit",
  ekstreTable: "b2b-ekstre-table",
  bakiyeDisplay: "b2b-bakiye-display",
};
